import { createClient } from '@supabase/supabase-js'

// Ensure these environment variables are set in your .env file
// VITE_SUPABASE_URL should be the project URL
// VITE_SUPABASE_ANON_KEY should be the public key (anon)
// Note: In Vite, environment variables must be accessed via import.meta.env with VITE_ prefix
const supabaseUrl = import.meta.env.VITE_SUPABASE_URL
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY

if (!supabaseUrl || !supabaseAnonKey) {
  throw new Error('Missing Supabase environment variables for client initialization.')
}

// Security check: Detect if service role key (secret key) is accidentally used
// Check the JWT payload instead of length, as both keys can be similar lengths

// Additional check: Service role keys often contain 'service_role' in their claims
try {
  const keyParts = supabaseAnonKey.split('.')
  if (keyParts.length >= 2) {
    const payload = JSON.parse(atob(keyParts[1]))
    if (payload.role === 'service_role') {
      throw new Error(
        'SECURITY ERROR: You are using a SERVICE ROLE KEY (secret key) in the browser. ' +
        'This is a critical security vulnerability! Service role keys bypass all security policies. ' +
        'Please immediately use the ANON KEY (public key) from Supabase Dashboard → Settings → API.'
      )
    }
  }
} catch (e) {
  // Only ignore parsing errors (JSON.parse or atob failures)
  // Re-throw security errors that we intentionally threw
  if (e instanceof Error && e.message.includes('SECURITY ERROR')) {
    throw e
  }
  // If parsing fails (not a JWT or malformed), continue with normal validation
  // This is acceptable as the key format may vary
}

// This client uses the public ANON key and is safe to use in the browser.
export const supabase = createClient(supabaseUrl, supabaseAnonKey)